import { PromoCondition, PromoToolSlot } from '@/types/amplience';

/**
 * The percentage condition of the active promotion that applies to a product type.
 *
 * Mirrors the product-type match in `useDiscountedPrice`, so the percentage advertised
 * before activation is the one the strikethrough applies afterwards. It deliberately
 * does *not* apply the `minOrderValue` / `minOrderItems` restrictions: those depend on
 * the cart, while the widget using this shows the minimum order value as a hint
 * (DEV-233329, AC 6) rather than hiding the promotion behind it.
 *
 * `productTypeCategories` are already resolved into `productTypes` server-side by
 * `fetchPromoSlot`, so matching on `productTypes` alone is enough.
 */
export const promoConditionForProductType = (
  promoSlot: PromoToolSlot | null,
  productTypeId: string | undefined
): PromoCondition | undefined => {
  if (!promoSlot || !productTypeId) return undefined;

  return promoSlot.content['promo-tool'].promoConditions
    .filter((condition) => condition.type === 'PercentageBased')
    .find(
      (condition) =>
        !condition.restrictions.productTypes?.length ||
        condition.restrictions.productTypes.includes(productTypeId)
    );
};
